import { Link } from 'react-router-dom';

const FinalCTA = () => {
  return (
    <section className="section-padding bg-gray-50">
      <div className="container-custom">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 text-accent">
            Learn more about<br />Real-Time Proof of Reserves
          </h2>
          <p className="text-base sm:text-lg text-gray-700 mb-8 max-w-3xl mx-auto">
            Audit Financier is an experienced and trusted blockchain auditing company that provides Real-Time PoR
            attestation services for digital asset service providers. Use the link below to book an introductory meeting
            with one of our experts. We develop the best software for attestations and real time monitoring, and we can
            help you implement it.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center justify-center px-8 sm:px-10 py-3 sm:py-4 rounded-full bg-accent text-white text-base sm:text-lg font-semibold transition-all duration-300 hover:bg-accent-600 hover:shadow-lg transform hover:scale-105"
          >
            <svg className="w-5 h-5 sm:w-6 sm:h-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            TALK TO AN EXPERT
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
